import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import StrongCTA from "../components/home/StrongCTA";

export default function FirmaPage() {
  useEffect(() => {
    document.title = "Quiénes somos | Ospino & Piñeres Abogados";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Page hero */}
      <section className="pt-36 pb-20 md:pt-44 md:pb-28 bg-white border-b border-slate-100">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="gold-rule" />
              <span className="overline">La firma</span>
            </div>
            <h1 className="font-serif text-navy-900 text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              Una firma <em className="italic" style={{ color: "#C5A059" }}>multidisciplinaria</em> al servicio del mundo empresarial.
            </h1>
            <p className="mt-7 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
              Ospino &amp; Piñeres Abogados &amp; Asociados S.A.S. es una firma especializada en asesoría jurídica y contable de alto nivel, orientada a empresas y organizaciones nacionales e internacionales con sede en la Costa Norte de Colombia.
            </p>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={120}>
            <img
              src="https://images.unsplash.com/photo-1775144657626-29ff0a46ca90"
              alt="Estudio jurídico con biblioteca"
              loading="lazy"
              className="w-full aspect-[4/5] object-cover"
            />
          </Reveal>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-5">
            <h2 className="font-serif text-navy-900 text-3xl md:text-4xl leading-tight">
              Cultura institucional
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Promovemos una cultura basada en pilares que orientan cada relación profesional y cada decisión técnica.
            </p>
          </Reveal>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-200">
            {[
              ["Ética", "Transparencia y rectitud en cada actuación."],
              ["Excelencia técnica", "Rigor y profundidad jurídica y contable."],
              ["Trabajo colaborativo", "Equipos integrados que suman miradas."],
              ["Compromiso institucional", "Acompañamiento real y duradero."],
            ].map(([t, d], i) => (
              <Reveal key={t} delay={i * 80}>
                <div className="bg-white p-8 h-full">
                  <span
                    className="text-xs font-bold uppercase tracking-[0.22em]"
                    style={{ color: "#C5A059" }}
                  >
                    {t}
                  </span>
                  <p className="mt-4 text-slate-700 leading-relaxed text-[15px]">
                    {d}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad" style={{ background: "#F8F9FA" }}>
        <div className="container-x">
          <Reveal className="max-w-3xl">
            <span className="overline">Mensaje clave</span>
            <p className="mt-5 font-serif italic text-navy-900 text-2xl md:text-3xl lg:text-4xl leading-snug">
              "No solo resolvemos problemas, prevenimos riesgos y fortalecemos decisiones."
            </p>
            <Link
              to="/servicios"
              className="mt-10 inline-flex items-center gap-2 text-sm font-medium text-navy-900 under-gold"
              data-testid="firma-cta-servicios"
            >
              Conocer nuestras áreas de práctica
              <ArrowRight size={15} />
            </Link>
          </Reveal>
        </div>
      </section>

      <StrongCTA />
    </>
  );
}